import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { Observable, throwError } from "rxjs";
import { environment } from '../../../environments/environment';
import { Assets, product } from '../../Class/Assets/assets';
import { map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { isPlatformBrowser, DOCUMENT } from '@angular/common';
import { ChangePassword,  ChangePasswordInput} from '../../class/Change-Password/change-password';


@Injectable({
    providedIn: 'root'
})
export class ChangePasswordService {

    private apiBaseUrl: string = environment.apiUrl;

    constructor(private http: HttpClient,
        @Inject(PLATFORM_ID) private platformId: Object,) { }


    UpdatePassword(formData: FormData): Observable<ChangePasswordInput> {

        if (isPlatformBrowser(this.platformId)) {

            const token: string | null = localStorage.getItem('token');

            const pec_ipaddress: string = localStorage.getItem('getip') || '0.0.0.0';
            const pec_browser: string = localStorage.getItem('getbrowser') || '-';
            const pec_browser_ver: string = localStorage.getItem('getbrowser_version') || '-';
            const pec_os: string = localStorage.getItem('getostype') || '-';

            formData.append('ipaddress', pec_ipaddress);
            formData.append('browser_ver', pec_browser);
            formData.append('browser', pec_browser_ver);
            formData.append('os', pec_os);

            const headers = new HttpHeaders({
                'Authorization': `Bearer ${token}`
            });

            return this.http.post<ChangePasswordInput>(`${this.apiBaseUrl}/api/change_password/ChangePassword`, formData, { headers })
                .pipe(map(response => response as ChangePasswordInput));
        } else {

            return throwError(() => new Error('err'));
        }

    };

    PasswordCheck(id: string): Observable<ChangePasswordInput> {

        if (isPlatformBrowser(this.platformId)) {

            const token: string | null = localStorage.getItem('token');

            const headers = new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            });

            const httpOptions = { headers };
            return this.http.get(`${this.apiBaseUrl}/api/change_password/PasswordCheck/${id}`, httpOptions).pipe(map(m => <ChangePasswordInput>m))

        } else {

            return throwError(() => new Error('err'));
        }
    };

}
